export default __webpack_public_path__ + "70b24b2c75171a084bb5be0a5ee7a773.png";